import { render } from "./DamageMap.vue?vue&type=template&id=039dbedb&scoped=true"
import script from "./DamageMap.vue?vue&type=script&lang=js"
export * from "./DamageMap.vue?vue&type=script&lang=js"

import "./DamageMap.vue?vue&type=style&index=0&id=039dbedb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039dbedb"]])

export default __exports__